import { ParentState } from "@checkout/types";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { CheckoutStepData } from "@hsbc/portal";

export const useFlightCheckoutHeaderSteps = (): CheckoutStepData[] => {
  const { t } = useI18nContext();
  return [
    {
      state: ParentState.contactAndTravelerInformation,
      label: t("checkoutSection.steps.passengerInformationStep"),
    },
    {
      state: ParentState.seatSelection,
      label: t("checkoutSection.steps.seatSelectionStep"),
    },
    {
      state: ParentState.payment,
      label: t("checkoutSection.steps.paymentStep"),
    },
    { state: ParentState.review, label: t("checkoutSection.steps.reviewStep") },
  ];
};
